import type React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';

import { actions as filterActions } from '../state/filterActions';
import { fetchResults } from '../state/resultActions';

import type { ApiQueryParams, PaleState } from '../interfaces';

interface Props {
    keywords: string;
    filterByKeywords: (keywords: string) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

export const KeywordFilter: React.FC<Props> = ({ keywords, filterByKeywords, triggerFetch }): React.ReactElement<Props> => {
    const [value, setValue] = useState(keywords);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setValue(event.target.value);
    };

    const onConfirm: () => void = (): void => {
        filterByKeywords(value);
        triggerFetch();
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (['Enter', 'NumpadEnter'].includes(event.key)) {
            onConfirm();
        }
    };

    return (
        <div className="input input--search u-mv32" id="keywordSearchFilter" data-testid="keywordSearchFilter">
            <label htmlFor="keywordFilter">Søk etter...</label>
            <input
                type="search"
                id="keywordFilter"
                data-testid="keywordFilter"
                maxLength={100}
                placeholder="F.eks treningsrom eller basseng"
                onChange={onChange}
                onBlur={onConfirm}
                onKeyDown={onKeyDown}
                defaultValue={keywords}
            />
            <button
                type="button"
                aria-label="Søk"
                className="input--search__button input--search__button--submit u-hide-lt768"
                id="keywordButton"
                data-testid="keywordFilterButton"
                onClick={onConfirm}
            />
        </div>
    );
};

const mapStateToProps = (state: PaleState): Pick<Props, 'keywords'> => ({ keywords: state.filters.keywords });

const mapDispatchToProps = { filterByKeywords: filterActions.filterByKeywords, triggerFetch: fetchResults };

export default connect(mapStateToProps, mapDispatchToProps)(KeywordFilter);
